
import { IPermissionInitialState } from "../../../types/permissions/permissionInterface";
import { PermissionActionTypes, PermissionActions } from "../../actionTypes/permissions/permissionTypes";

const initialState: IPermissionInitialState = {
  permissionList: [],
  permissionPageCount: 0,
  permissionById: {
    id: 0,
    role_name: "",
    sections: [],
    assigned_permissions: []
  }
};

export default function permissionReducer(state = initialState, action: PermissionActionTypes): IPermissionInitialState {
  switch (action.type) {
    case PermissionActions.SET_PERMISSION_LIST:
      return {
        ...state,
        permissionList: action.payload,
      };

    case PermissionActions.SET_PERMISSION_PAGE_COUNT:
      return {
        ...state,
        permissionPageCount: action.payload
      };

    case PermissionActions.SET_PERMISSION_BY_USERID:
      return {
        ...state,
        permissionById: action.payload
      };


    default:
      return state;
  }
}
